import React from 'react'
import { observer } from 'mobx-react-lite'

import { useTheme } from '@mui/material/styles'

import { useCategoryStore, useGlobalCopyStore, useWidgetContainerProvider } from '../../common'
import { LineChart } from '../../common/components/charts/LineChart'

import { getSpendingData } from '../utils/SpendingData'

const SpendingChart = () => {
  const { monthlyCategoryTotals } = useCategoryStore()
  const { trends: trendsCopy } = useGlobalCopyStore()
  const theme = useTheme()
  const { availableHeight = 300 } = useWidgetContainerProvider()

  const data = React.useMemo(() => getSpendingData(monthlyCategoryTotals), [monthlyCategoryTotals])

  return (
    <LineChart
      baseline="min"
      colors={[theme.palette.primary.main]}
      datasets={[data]}
      height={availableHeight}
      labels={[trendsCopy.spending_label]}
      showArea={true}
      showAverage={true}
      showLegend={true}
      showMarkLabel={true}
      useCustomMark={true}
      valueFormatterString="0,0"
    />
  )
}

export default observer(SpendingChart)
